import { AuthenticationService } from '../../services/auth.service';
import { catchError, Subscription, throwError } from 'rxjs';
import { CommunicationService } from '../../services/utelize/system/communication/communication-service';
import { CommunicationDTO } from '../../models/system/communication/communication.dto';
import { Component, EventEmitter, OnDestroy, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { ConfigSystemParams, TypeCommunication } from '../../consts';
import { ConfigSystemService } from '../../services/utelize/system/config-system/config-system-service';
import { environment } from 'src/environments/environment';
import { ExceptionsService } from '../../services/utelize/general/exceptions-service';
import { IdAndDescriptionDTO } from '../../interfaces/general/id-description';
import { NgbDropdown, NgbNav } from '@ng-bootstrap/ng-bootstrap';
import { SystemUserDTO } from '../../models/system/user/system-user.dto';
import { TypesCommunicationService } from '../../services/utelize/system/type/types-communication-service';

@Component({
  selector: 'app-page-comp-menu-notifications',
  templateUrl: './page-comp-menu-notifications.component.html',
  styleUrls: ['./page-comp-menu-notifications.component.scss']
})

export class PageCompMenuNotificationsComponent implements OnDestroy, OnInit {
  
  @Output() openCommunicationModal: EventEmitter<number>=new EventEmitter<number>();
  @Output() viewNotifications     : EventEmitter<string>=new EventEmitter<string>();
  
  @ViewChild('dropdown',           { static: false }) dropdown!          : NgbDropdown;
  @ViewChild('nav',                { static: true })  nav!               : NgbNav;
  @ViewChild('removeNotification')                    removeNotification!: TemplateRef<any>;
    
  get titlesUseSureSimBlue() { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.PagesTitlesUseSureSimBlue, false); }
  
  private alertTypeId      : number | undefined;
  private messageId        : number | undefined;
  private subNotifications!: Subscription | undefined;

  public allnotifications    : CommunicationDTO[]=[];
  public alerts              : CommunicationDTO[]=[];
  public isPlatformModeInview: boolean=environment.platformModeInview;
  public curUser             : SystemUserDTO;
  public messages            : CommunicationDTO[]=[];
  
  constructor(
    private authenticationService    : AuthenticationService,
    private communicationService     : CommunicationService,
    private configSystemService      : ConfigSystemService,
    private exceptionsService        : ExceptionsService,
    private typesCommunicationService: TypesCommunicationService
  ) {
    this.curUser=this.authenticationService.currentUserObject();
  }

  public ngOnInit(): void {
    try {
      this.getIdsForCommunicationTypes();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public ngOnDestroy() {
    try {
      this.unsubscribeNotifications();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public onDropdownChange(): void {
    try {
      this.nav.select(1);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
    
  public getIdsForCommunicationTypes() {
    try {
      this.typesCommunicationService.getIdAndDescription()
      .pipe(
        catchError((error) => {
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
        })
      )
      .subscribe({
        next: data => {
          let typeCommunication: IdAndDescriptionDTO | undefined=data.find(x => x.description==TypeCommunication.Alert);
  
          if (!typeCommunication)
            this.exceptionsService.handleException(new Error(`PageCompMenuNotificationsComponent - CommunicationType for ${TypeCommunication.Alert} cannot be determined`));
  
          this.alertTypeId=Number(typeCommunication?.id);

          typeCommunication=data.find(x => x.description==TypeCommunication.Message);
  
          if (!typeCommunication)
            this.exceptionsService.handleException(new Error(`PageCompMenuNotificationsComponent - CommunicationType for ${TypeCommunication.Message} cannot be determined`));
  
          this.messageId=Number(typeCommunication?.id);

          this.getNotifications();
        },
        error: error => {
          this.exceptionsService.handleException(new Error(error));
        }
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public getNotifications() {
    try {
      this.unsubscribeNotifications();

      this.subNotifications=this.communicationService.getForLoggedInUserActiveOnlyUpdates(this.curUser.userId)
                            .pipe(
                              catchError((error) => {          
                                return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
                              })
                            )
                            .subscribe({
                              next: data => {  
                                this.allnotifications=[];
                                this.alerts          =[];
                                this.messages        =[];

                                for (const message of data) {
                                  this.allnotifications.push(message);

                                  if (message.communicationTypeID==this.alertTypeId) {
                                    message.icon="bx-error";
                                    this.alerts.push(message);
  
                                  } else if (message.communicationTypeID==this.messageId) {
                                    message.icon="bx-envelope";
                                    this.messages.push(message);
  
                                  }
                                }
                              },
                              error: error => {
                                this.exceptionsService.handleException(new Error(error));
                              }
                            });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
      
  public unsubscribeNotifications() {
    try {
      if (this.subNotifications) {
        this.subNotifications.unsubscribe();
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public openCommunication(communicationId: number) {
    try {
      this.dropdown.close();
      this.openCommunicationModal.emit(communicationId);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public viewAllNotifications() {
    try {
      this.dropdown.close();
      this.viewNotifications.emit(TypeCommunication.All);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
}
